import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { SendSupplierEmailFormContainerProps } from "models/propTypes/incomingInvoicePropTypes";
import { UtilFormTypes } from "models/formTypes";
//#endregion
//#region components
import { SendEmailForm } from "components/common";
import { Description, Label } from "components/common/wintForms";
import { Grid } from "@mui/material";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import * as Yup from "yup";

const SendSupplierEmailFormContainer: ForwardRefRenderFunction<FormHandles, SendSupplierEmailFormContainerProps> = (
  props,
  ref
) => {
  const incomingInvoiceService = useIncomingInvoiceService();
  const { invoiceId } = props;

  const validationSchema = Yup.object<UtilFormTypes.Email>({
    to: Yup.string().required(TranslationKeys.Validations.Required),
    subject: Yup.string().required(TranslationKeys.Validations.Required),
    message: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const onFormSubmit = async (values: UtilFormTypes.Email) => {
    return incomingInvoiceService.sendEmailToSupplier({
      ...values,
      confirmEmailSending: true,
      incomingInvoiceId: invoiceId,
    });
  };

  return (
    <Grid container item spacing={2}>
      <Grid item container>
        <Description>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Supplier.EmailDialogTitle)}
        </Description>
      </Grid>
      <Grid item container>
        <Label>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Supplier.EmailDialogSubTitle)}</Label>
        <SendEmailForm
          ref={ref}
          defaultValues={props.emailInfo}
          validationSchema={validationSchema}
          handleSubmit={onFormSubmit}
          emailSuggestions={props.emailSuggestions}
          disableSubject
          disableMessage
        />
      </Grid>
    </Grid>
  );
};

export default forwardRef(SendSupplierEmailFormContainer);
